import { Component } from '@angular/core';
import { BaseDatatableHeaderComponent } from '../base-datatable-header.component';

@Component({
  template: `
    <app-input-multi-select
      [options]="options"
      [optionLabel]="optionLabel"
      [placeholder]="placeholder"
      (select)="onSelect($event)"
      [fullWidth]="true"
    />
  `,
})
export class InputMultiselectHeaderComponent extends BaseDatatableHeaderComponent {
  get options() {
    return this.colDef().custonConfig?.['options'] ?? [];
  }
  get optionLabel() {
    return this.colDef().custonConfig?.['optionLabel'] ?? '';
  }

  get placeholder() {
    return this.colDef().custonConfig?.['placeholder'] ?? '';
  }

  onSelect(event: Record<string, unknown>[]) {
    const keyFilter =
      this.colDef().custonConfig?.['keyFilter'] ?? 'adicionarKeyFilter';

    this.onFilterChange()({ [keyFilter]: event });
  }
}
